import { render, staticRenderFns } from "./LicenseGenerationsTab.vue?vue&type=template&id=d36dd300&lang=pug"
import script from "./LicenseGenerationsTab.vue?vue&type=script&lang=js"
export * from "./LicenseGenerationsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports